import { VoiceButton } from '@voice-ai-workforce/react';
import { 
  VoiceAIConfig, 
  AIProvider, 
  SpeechProvider, 
  ResponseMode 
} from '@voice-ai-workforce/react';

export function VoiceAIAgent() {
  // ✅ FIXED: Proper configuration with required fields
  const config: VoiceAIConfig = {
    // 🔥 REQUIRED: AI Providers configuration
    aiProviders: {
      primary: {
        provider: AIProvider.OPENAI,
        apiKey: 'your-api-key-here',
        model: 'gpt-3.5-turbo'
      },
      // Optional: Add fallback
      fallbacks: [{
        provider: AIProvider.KEYWORDS,
        fallbackMode: true
      }]
    },
    
    // Speech configuration
    speechToText: {
      provider: SpeechProvider.WEB_SPEECH,
      language: 'en-US',
      continuous: false
    },
    textToSpeech: {
      provider: SpeechProvider.WEB_SPEECH,
      speed: 1.0
    },
    
    // Response mode
    responseMode: ResponseMode.BOTH,
    
    // 🎨 NEW: Choose your interface mode
    interfaceMode: 'end-user', // 'developer' | 'project' | 'end-user'
    
    // Optional: API base URL
    apiBaseUrl: 'https://api.openai.com/v1'
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ marginBottom: '20px' }}>
        <VoiceButton
          config={config}
          size="md"
          variant="secondary"
          onCommand={(cmd) => {
            console.log('Voice command received:', typeof cmd === 'object' ? JSON.stringify(cmd) : cmd);
            // Handle the command in your app
          }}
          onResponse={(res) => {
            console.log('AI response:', res);
            // Handle the AI response
          }}
          onError={(error) => {
            console.error('Voice AI error:', error);
            // Handle errors gracefully
          }}
        />
      </div>
    </div>
  );
}
